import React, {Component} from "react";

class TournamentLeaderboardTab extends Component {

    clickFunc() {
        let {current_type, type, click_func} = this.props;

        if (type !== current_type) {
            click_func(type);
        }
    }


    render() {       
        let {type, text, current_type} = this.props; 

        let tabClass = "tournament_leaderboard_tab ";

        if (type === current_type) {
            tabClass += "selected";
        }


        return (
            <div className={tabClass} onClick={this.clickFunc.bind(this)}>
                {text.split("\n").map(function (textPart, i) {
                  return <div key={i}>{textPart}</div>;  
                })}
            </div>
        );    
       
        
    }
}

export default TournamentLeaderboardTab;


// WEBPACK FOOTER //
// ./src/components/containers/tournaments/tournament-leaderboard-tab.js